import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// antd's own base stylesheet — must load BEFORE theme.css so our overrides
// (many using specificity or !important) layer on top correctly. Without
// this, antd's structural CSS (Layout's flex row-with-sider behavior, Menu's
// text-overflow handling, Input's default border, etc.) never loads at all,
// which was the real cause of the sidebar overlap and harsh input borders.
import "antd/dist/antd.css";
import "./styles/theme.css";

import apiPath from "./constants/apiPath";
import { bootstrapTeams, openedInTeams } from "./helper/teams";

// Pages a Teams alert is allowed to open (see helper/teams.js).
const TEAMS_PAGES = [
  "/dashboard", "/employees", "/departments", "/roles", "/offices", "/working-hours", "/attendance",
  "/activity-history", "/holidays", "/policies", "/leave", "/leave-settings", "/leave-requests", "/wfh-requests", "/pay-run",
  "/reimbursements", "/overtime-requests", "/benefits", "/reports", "/audit-log",
];

async function start() {
  const rootEl = document.getElementById("root");
  // Opened as a Teams tab: sign in with Microsoft and open the linked page first.
  if (openedInTeams()) {
    rootEl.innerHTML = '<div style="font-family:Inter,system-ui,sans-serif;color:#6B7280;display:flex;align-items:center;justify-content:center;height:100vh">Signing you in…</div>';
    await bootstrapTeams({
      tokenKey: "i_ems_admin_token",
      profileKey: "i_ems_admin_profile",
      ssoUrl: apiPath.baseURL + apiPath.teamsSso,
      allowedPaths: TEAMS_PAGES,
    });
  }
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
start();

// Register the service worker so this app can receive Web Push notifications
// even when the tab/app is closed (Chrome/Firefox/Edge desktop + Android Chrome).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js");
  });
}
